import { httpClient } from '../http/httpClient'

type GetCommissionParams = {
  prazo: number
}

type GetCommissionResponse = {
  commission: number
}

export async function getCommission(params: GetCommissionParams) {
  const { data } = await httpClient
    .get<GetCommissionResponse>('/crefaz', { params })
    .catch((error) => {
      throw error.response?.data ?? error
    })

  return data
}
